import styled from 'styled-components';

import style from '../../../style';
import type { Size } from '../../../style/types/theme';
import { BorderRadiusSize, Variant } from '../types';

interface BlockingAreaContainerProps {
  $borderRadiusSize?: BorderRadiusSize;
}

interface WrapperProps {
  $isClickable?: boolean;
  $isActive?: boolean;
  $blockingAreaId?: string;
  $variant?: Variant;
}

const getBorderRadiusSize = (size: Size, borderRadiusSize?: BorderRadiusSize) => {
  switch (borderRadiusSize) {
    case BorderRadiusSize.SMALL:
      return size.units(0.5);
    case BorderRadiusSize.MEDIUM:
      return size.units(1);
    case BorderRadiusSize.BIG:
      return size.units(2);
    case BorderRadiusSize.NONE:
    default:
      return 0;
  }
};

export const BlockingAreaContainer = styled.div<BlockingAreaContainerProps>(
  ({ theme: { color, transition, size }, $borderRadiusSize }) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: transition.standard('opacity'),
    backgroundColor: color.background.reversed.default(0.8),
    opacity: 0,
    borderRadius: getBorderRadiusSize(size, $borderRadiusSize),

    ...style.mixins.devices.touchable({
      opacity: 1,
    }),
  }),
);

export const Wrapper = styled.div<WrapperProps>(
  ({ $isClickable, $isActive, $variant }) => ({
    overflow: $isActive ? 'hidden' : undefined,
    cursor: $isClickable && $isActive ? 'pointer' : undefined,
    position: 'relative',
    height: '100%',
    width: $variant === Variant.INLINE ? '100%' : undefined,

    ':hover >': {
      [BlockingAreaContainer]: {
        opacity: 1,
      },
    },

    [`& > ${BlockingAreaContainer}`]: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 2,
    },
  }),
);
